export const DISPLAY_ON_MAP_HINT = 'Toggling this button off will hide the features from the map.';
export const DISPLAY_IN_LEGEND_HINT =
  'Toggling this button off will move the layer to the Hidden Layers tab in the legend. It will not be visible in the main legend, but will be visible on the map if “Display on Map” is toggled on.';
export const DOWNLOADABLE_HINT = 'Toggling this button off will prevent Viewers from downloading the dataset from any tools.';

type ColorRamp = { id: string; colors: string[] };

export const COLOR_RAMPS: ColorRamp[] = [
  {
    id: 'greenToBlue',
    colors: [
      '#e9f7ef',
      '#ddf4e8',
      '#d1f1e0',
      '#c5eed9',
      '#b9ebd1',
      '#9fe3c2',
      '#85dbb3',
      '#6cd3a4',
      '#52cb95',
      '#45b284',
      '#389a73',
      '#2b8162',
      '#1e6951',
      '#14503f',
      '#0a372d',
    ],
  },
  {
    id: 'pastelMulti',
    colors: [
      '#f2f2f2',
      '#dcdfe6',
      '#c7ccd9',
      '#b1bacd',
      '#9ba7c1',
      '#a7cab7',
      '#b4eca4',
      '#e0f6a1',
      '#fffda0',
      '#e4d1c6',
      '#caa8ed',
      '#d775b6',
      '#e53a80',
      '#c72a75',
      '#aa1b6a',
    ],
  },
  {
    id: 'blueScale',
    colors: [
      '#eef6fc',
      '#e1eff8',
      '#d3e7f4',
      '#c6e0f0',
      '#b8d8ec',
      '#9bc4e0',
      '#7fb1d5',
      '#629dca',
      '#468abf',
      '#3876a8',
      '#2b628f',
      '#1e4e76',
      '#123a5d',
      '#0c2b48',
      '#061c33',
    ],
  },
  {
    id: 'brownToGreen',
    colors: [
      '#f3e5d8',
      '#ecd4b6',
      '#e5c493',
      '#dcb471',
      '#d3a44e',
      '#b5c899',
      '#97ed44',
      '#70d576',
      '#4abe78',
      '#3b9b62',
      '#2d784c',
      '#235c42',
      '#1a4d39',
      '#123c30',
      '#0b2b27',
    ],
  },
  {
    id: 'blueToPurple',
    colors: [
      '#e6eef7',
      '#d7e2f2',
      '#c9d7ed',
      '#bbcbe8',
      '#adbee3',
      '#89a0d2',
      '#6682c1',
      '#4363b0',
      '#21449f',
      '#19377d',
      '#12295b',
      '#0a1c39',
      '#07162e',
      '#051124',
      '#040c1a',
    ],
  },
  {
    id: 'multiBold',
    colors: [
      '#e9f5f3',
      '#bfdcd4',
      '#96c3b6',
      '#6ca998',
      '#43907a',
      '#5fa677',
      '#7cbd75',
      '#98d472',
      '#b5eb70',
      '#9cc9a4',
      '#83a6d9',
      '#5d7eb7',
      '#375795',
      '#243d72',
      '#112350',
    ],
  },
  {
    id: 'greyScale',
    colors: [
      '#f8f9fa',
      '#eceef1',
      '#e1e3e7',
      '#d5d8dd',
      '#cacdd3',
      '#b1b6bb',
      '#989ba0',
      '#7f8185',
      '#66676a',
      '#505053',
      '#3b3b3d',
      '#2a2a2b',
      '#1d1d1d',
      '#141414',
      '#0a0a0a',
    ],
  },
  {
    id: 'heat',
    colors: [
      '#fff7d1',
      '#feeeb8',
      '#fde69f',
      '#fddc86',
      '#fdd36d',
      '#fcb34c',
      '#fa942b',
      '#f77417',
      '#e85a10',
      '#d94109',
      '#c72d05',
      '#b02203',
      '#991a02',
      '#821101',
      '#6b0900',
    ],
  },
  {
    id: 'peachToRust',
    colors: [
      '#fff3df',
      '#fee3c7',
      '#fed3af',
      '#fdb497',
      '#fb957f',
      '#f56f57',
      '#e14943',
      '#cb3232',
      '#b51f26',
      '#9e111b',
      '#870812',
      '#70040c',
      '#590207',
      '#420104',
      '#2b0002',
    ],
  },
  {
    id: 'rustToCream',
    colors: [
      '#701c1b',
      '#8b2a26',
      '#a73932',
      '#c1473c',
      '#db5547',
      '#ef7a64',
      '#f39d83',
      '#f7bfa4',
      '#fbdfc5',
      '#fff2e7',
      '#fff9f0',
      '#fffdf7',
      '#fefefe',
      '#ffffff',
      '#ffffff',
    ],
  },
  {
    id: 'blueGreenCoral',
    colors: [
      '#c7dcef',
      '#aacce4',
      '#8dbbdd',
      '#70abd5',
      '#549bcc',
      '#63b087',
      '#72c543',
      '#8cd47b',
      '#a6e3b3',
      '#edcfbf',
      '#d9a894',
      '#c4816a',
      '#b05b41',
      '#9a432d',
      '#852b19',
    ],
  },
  {
    id: 'pastelRainbow',
    colors: [
      '#ffcdd2',
      '#f9b2c1',
      '#f098d0',
      '#e67de0',
      '#d962f0',
      '#c6a5f5',
      '#b2e9fa',
      '#bbf1ef',
      '#c5f8e3',
      '#d7f2c1',
      '#e9eba0',
      '#fcf48d',
      '#fff57a',
      '#fff367',
      '#fff154',
    ],
  },
  {
    id: 'aquaToGrey',
    colors: [
      '#ddf2ed',
      '#cde9e1',
      '#bddfd5',
      '#aed6ca',
      '#9eccc0',
      '#c9c9cf',
      '#d4d4d9',
      '#dfdfdf',
      '#eaeaea',
      '#dddddd',
      '#cfcfcf',
      '#c2c2c2',
      '#b5b5b5',
      '#a9a9a9',
      '#9c9c9c',
    ],
  },
  {
    id: 'magentaToGreen',
    colors: [
      '#f3d0e6',
      '#eab7d8',
      '#e09dca',
      '#d684bc',
      '#cb6aae',
      '#a9a78d',
      '#88c26a',
      '#75b75a',
      '#63ab4a',
      '#549e3d',
      '#468130',
      '#386423',
      '#2b4717',
      '#1e2a0c',
      '#121f06',
    ],
  },
  {
    id: 'purpleToLime',
    colors: [
      '#ede3f6',
      '#d5c5ee',
      '#bea7e7',
      '#a689df',
      '#8e6bd7',
      '#bcd8ac',
      '#a2cc85',
      '#88c05d',
      '#6fb536',
      '#5a9e2c',
      '#468822',
      '#337218',
      '#215c0f',
      '#16480a',
      '#0c3506',
    ],
  },
  {
    id: 'softBlueTeal',
    colors: [
      '#f7f2fb',
      '#ccd4e5',
      '#9fbad0',
      '#6fa6b9',
      '#2f6d62',
      '#347768',
      '#39816d',
      '#3e8b73',
      '#439579',
      '#3f8367',
      '#3b7055',
      '#375d43',
      '#334a31',
      '#2f3720',
      '#2a240f',
    ],
  },
  {
    id: 'orangeViolet',
    colors: [
      '#d96a1f',
      '#efaf62',
      '#fffdfc',
      '#b8b1d4',
      '#4d2d83',
      '#5a3a91',
      '#67479f',
      '#7454ad',
      '#8161bb',
      '#6c519d',
      '#573f7f',
      '#422e61',
      '#2e1e43',
      '#1a0e25',
      '#050007',
    ],
  },
  {
    id: 'lavenderPinkWine',
    colors: [
      '#f4f1f8',
      '#e2d3ea',
      '#d1b5dc',
      '#bf97ce',
      '#ad79c0',
      '#ba4f85',
      '#c32576',
      '#cc0067',
      '#c00054',
      '#ae0048',
      '#9c003c',
      '#8a0030',
      '#780024',
      '#660018',
      '#54000c',
    ],
  },
  {
    id: 'paleBlueIndigo',
    colors: [
      '#f4f3fb',
      '#d8d8eb',
      '#bebeda',
      '#a3a3c9',
      '#8989b8',
      '#6d6da7',
      '#525296',
      '#3a3a85',
      '#262673',
      '#1c1c5e',
      '#131349',
      '#0b0b34',
      '#070726',
      '#040418',
      '#010109',
    ],
  },
  {
    id: 'warmRedBlue',
    colors: [
      '#b72626',
      '#e3ab8e',
      '#ffffff',
      '#9fc4db',
      '#336699',
      '#2d5b88',
      '#264f77',
      '#1f4466',
      '#183855',
      '#143049',
      '#0f273c',
      '#0b1f2f',
      '#071723',
      '#040f16',
      '#01070a',
    ],
  },
  {
    id: 'peachPinkPurple',
    colors: [
      '#fbe8df',
      '#f5b9c0',
      '#ee8ab0',
      '#e75ba0',
      '#df2c90',
      '#c02582',
      '#a11e75',
      '#821768',
      '#64105b',
      '#4b0a4a',
      '#330639',
      '#1e0428',
      '#0f0218',
      '#06010e',
      '#020005',
    ],
  },
  {
    id: 'peachOrangeRed',
    colors: [
      '#fbeee5',
      '#f7cfb9',
      '#f3af8d',
      '#ef8f61',
      '#eb6f35',
      '#e14a1d',
      '#d72506',
      '#c51d05',
      '#b31604',
      '#a20f04',
      '#910a03',
      '#800602',
      '#6f0401',
      '#5e0301',
      '#4d0200',
    ],
  },
];
